// loading checklist — (D1-backed, keyed by SAP). Items with a matching PDI row sync both ways with the
// PDI sheets (see loadingPdi.ts).
export const LOADING_ITEMS = [
    'Τραπέζι',
    'Στύλος Τραπεζιού',
    'Plexi ψυγείου B2B',
    'Ηλεκτρικό/φορητό ψυγείο',
    'Wash down hose',
    'Μπαλόνια',
    'Σχοινιά',
    'Φορτιστής',
    'Ηλεκτρική τρόμπα',
    'Extension ηλ. τρόμπας',
    'Τάπες throughull',
    'Τηλεχειριστήριο εργάτη',
    'Καφετριέρα',
    'Κλειδιά μηχανών',
    'Κλειδιά καμπίνας (40/47)',
    'Parking Cover',
    'Console Cover',
    'Sun Deck And Seats Cover',
    'Sun tent',
    'Poles',
    'Πλαϊνά Βινύλια - T top',
    'Sunbed',
    'Στύλος Sunbed',
    'Σχοινί ρυμούλκησης',
    'Μπλε ματσουκάκι για 600ρια',
    'Ασφάλειες μηχανών (ηλεκτρικά τιμόνια)',
    'Τσάντα με Manuals',
    'Τσάντα gimmicks',
];
/** progress from a lookup of each item's status (a missing item is pending). */
export function loadingProgress(statusOf) {
    let loadedN = 0;
    let na = 0;
    for (let i = 0; i < LOADING_ITEMS.length; i++) {
        const st = statusOf(i) ?? 'pending';
        if (st === 'loaded')
            loadedN++;
        else if (st === 'na')
            na++;
    }
    const applicable = LOADING_ITEMS.length - na;
    return { loadedN, na, applicable, done: applicable === 0 ? na > 0 : loadedN >= applicable };
}
/** progress for every boat that has at least one stored item, keyed by SAP. */
export function loadingProgressBySap(items) {
    const bySap = new Map();
    for (const it of items) {
        let m = bySap.get(it.sap);
        if (!m)
            bySap.set(it.sap, (m = new Map()));
        m.set(it.itemNo, it.status);
    }
    const out = new Map();
    for (const [sap, m] of bySap)
        out.set(sap, loadingProgress((i) => m.get(i)));
    return out;
}
//# sourceMappingURL=loading.js.map